import React from 'react';
import { withTranslation } from 'react-i18next';
import { renderLink } from '../utils';

class MenuFaq extends React.Component<any, any> {
  faqLink: string;

  constructor(props: any) {
    super(props);

    this.handleOnSelectChange = this.handleOnSelectChange.bind(this);

    this.state = {};
    this.faqLink =  this.props.newFaqIsEnabled ? '/help' : '/faq';
  }

  private handleOnSelectChange(e: any) {
    if(this.props.onChange) {
      this.props.onChange(e.target.value);
    }
  }

  render() {
    /*const renderAvantVenteMenuDesktop = () => {
      return (
        <div className="d-flex flex-column rubriqueMenuFaq">
          <p className="text-uppercase mt-2 mb-2 red font-weight-bold border-bottom border-red">
            {this.props.t('pre_purchase')}
          </p>
          {renderLink('/'+this.props.i18n.language+'/faq/livraison', this.props.t('delay_shipping'), '/faq?tag=livraison')}
          {renderLink('/'+this.props.i18n.language+'/faq/moyens-de-paiement', this.props.t('means_of_payment'), '/faq?tag=moyens-de-paiement')}
        </div>
      );
    };

    const renderAvantVenteMenuMobile = () => {
      return (
        <>
          <option disabled className="text-uppercase  red font-weight-bold">{this.props.t('pre_purchase')}</option>
          <option value="livraison">{this.props.t('delay_shipping')}</option>
          <option value="moyens-de-paiement">{this.props.t('means_of_payment')}</option>
        </>
      );
    };

    const renderMarquageMenuDesktop = () => {
      return (
        <div className="d-flex flex-column rubriqueMenuFaq">
          <p className="text-uppercase mt-3 mb-1  red font-weight-bold border-bottom border-red">
            {this.props.t('marking')}
          </p>
          {renderLink('/'+this.props.i18n.language+'/faq/preparer-mon-fichier-tiff', this.props.t('prepare_my_file'), '/faq?tag=preparer-mon-fichier-tiff')}
        </div>
      );
    };

    const renderMarquageMenuMobile = () => {
      return (
        <>
          <option disabled className="text-uppercase  red font-weight-bold">{this.props.t('marking')}</option>
          <option value="preparer-mon-fichier-tiff">{this.props.t('prepare_my_file')}</option>
        </>
      );
    };

    const renderCommandesMenuDesktop = () => {
      return (
        <div className="d-flex flex-column rubriqueMenuFaq">
          <p className="text-uppercase mt-4 mb-2 red font-weight-bold border-bottom border-red">
            {this.props.t('your_orders')}
          </p>
          {renderLink('/'+this.props.i18n.language+'/faq/suivre-ma-commande', this.props.t('title-suivre-ma-commande'), '/faq?tag=suivre-ma-commande')}
        </div>
      );
    };

    const renderCommandesMenuMobile = () => {
      return (
        <>
          <option disabled className="text-uppercase red font-weight-bold">{this.props.t('your_orders')}</option>
          <option value="suivre-ma-commande">{this.props.t('title-suivre-ma-commande')}</option>
        </>
      );
    };*/

    const renderFAQMenuDesktop = () => {
      return (
        <div className="d-flex flex-column rubriqueMenuFaq">
          <p className="text-uppercase mt-3 mb-1  red font-weight-bold border-bottom border-red">
            {this.props.t('need_help')}
          </p>
          {renderLink('/'+this.props.i18n.language+this.faqLink, this.props.t('title-faq'), this.faqLink)}
        </div>
      );
    };

    const renderFAQMenuMobile = () => {
      return (
        <>
          <option disabled className="text-uppercase  red font-weight-bold">{this.props.t('need_help')}</option>
          <option value={this.faqLink}>{this.props.t('title-faq')}</option>
        </>
      );
    };

    const renderInformationsMenuDesktop = () => {
      return (
        <div className="d-flex flex-column font14 rubriqueMenuFaq">
          <p className="text-uppercase mt-3 mb-2 red font-weight-bold font16 border-red">
            {this.props.t('informations')}
          </p>
          {renderLink(`/${this.props.i18n.language}/faq/conditions-generales-de-vente`, this.props.t('terms_of_sales'), '/faq?tag=conditions-generales-de-vente')}
          {renderLink(`/${this.props.i18n.language}/faq/politique-des-retours`, this.props.t('returns_policy'), '/faq?tag=politique-des-retours')}
          {renderLink(`/${this.props.i18n.language}/faq/politique-generale-de-protection-des-donnees`, this.props.t('privacy_policy'), '/faq?tag=politique-generale-de-protection-des-donnees')}
          {renderLink(`/${this.props.i18n.language}/faq/politique-de-cookies`, this.props.t('cookies_policy'), '/faq?tag=politique-de-cookies')}
          {renderLink(`/${this.props.i18n.language}/faq/mentions-legales`, this.props.t('legal_notice'), '/faq?tag=mentions-legales')}
        </div>
      );
    };

    const renderInformationsMenuMobile = () => {
      return (
        <>
          <option disabled className="text-uppercase  red font-weight-bold">{this.props.t('informations')}</option>
          <option value="/faq/conditions-generales-de-vente">{this.props.t('terms_of_sales')}</option>
          <option value="/faq/politique-des-retours">{this.props.t('returns_policy')}</option>
          <option value="/faq/politique-generale-de-protection-des-donnees">{this.props.t('privacy_policy')}</option>
          <option value="/faq/politique-de-cookies">{this.props.t('cookies_policy')}</option>
          <option value="/faq/mentions-legales">{this.props.t('legal_notice')}</option>
        </>
      );
    };

    const renderMenuDesktop = () => {
      return (
        <div className="d-none d-sm-block">
          {/*renderAvantVenteMenuDesktop()*/}
          {/*renderMarquageMenuDesktop()*/}
          {/*renderCommandesMenuDesktop()*/}
          {renderFAQMenuDesktop()}
          {renderInformationsMenuDesktop()}
        </div>
      );
    };

    const renderMenuMobile = () => {
      const defaultValue = this.props.tag === '' ? this.faqLink : `/faq/${this.props.tag}`;

      return (
        <select className="d-block d-sm-none col-12 p-0" defaultValue={defaultValue} onChange={this.handleOnSelectChange}>
          {/* renderAvantVenteMenuMobile()*/}
          {/* renderMarquageMenuMobile()*/}
          {/* renderCommandesMenuMobile()*/}
          {renderFAQMenuMobile()}
          {renderInformationsMenuMobile()}
        </select>
      );
    };

    return (
      <>
        {renderMenuDesktop()}
        {renderMenuMobile()}
      </>
    );
  }
}

export default withTranslation('faq')(MenuFaq);
